import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import AsideMenuWrap from './assideMenu/AsideMenuWrap';
import AsideMenuWrapBurger from './assideMenu/AsideMenuWrapBurger';
import HeaderUserDash from './HeaderUserDash';
import BodyDashboard from './BodyDashboard';
import '../../styles/dashboard.scss';
import {useInitServerDashboard} from '../../hooks/useInitServerDashboard';

const DashboardWrap = () => {
  const [isOpenAside, setIsOpenAside] = useState(true);
  const {selectedServer} = useInitServerDashboard();
  const [eqv, setEqv] = useState('Overview');
  const {overviewGlobalState} = useSelector((state) => state.overview);

  const handleResize = () => {
    if (window.innerWidth > 1600) {
      setIsOpenAside(false);
    } else {
      setIsOpenAside(true);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="dashboard_wrap">
      <div className="dashboard_wrap_asside_menu_block">
        {!isOpenAside ? (
          <AsideMenuWrapBurger
            item={selectedServer}
            setEqv={setEqv}
            eqv={eqv}
            isOpenAside={isOpenAside}
            setIsOpenAside={setIsOpenAside}
            overview={overviewGlobalState?.data}
          />
        ) : (
          <AsideMenuWrap
            item={selectedServer}
            setEqv={setEqv}
            eqv={eqv}
            isOpenAside={isOpenAside}
            setIsOpenAside={setIsOpenAside}
            overview={overviewGlobalState?.data}
          />
        )}
      </div>
      <div className="dashboard_wrap_body_block">
        <HeaderUserDash setIsOpenAside={setIsOpenAside} />
        <BodyDashboard eqv={eqv} item={selectedServer} />
      </div>
    </div>
  );
};

export default DashboardWrap;
